import { defineMessage } from '@redbubble/next/intl';
import ex2MImg from '../assets/models/ex2_m.png';
import { PreQuerySizeGuideData } from '../types';
import {
  howToChooseSizeTshirtInstructions,
  internationalConversions,
  TSHIRT_ILLUSTRATION_PATH,
} from './sharedSizeGuideData';

/**
 * Experience 2
 * Premium T-Shirt
 * sooky-sanga
 * Data source: https://www.figma.com/file/APrcJzL2qFEoaRd5cHKcR6/Sizing---VM?node-id=102%3A1188&t=HmvOZ0xrFXTSRYSx-1
 */

export const experience2: PreQuerySizeGuideData = {
  internationalConversions,
  fitIndicator: {
    value: 5 /* 1 - 10 */,
  },
  howToChooseSize: {
    imageUrl: TSHIRT_ILLUSTRATION_PATH,
    instructions: howToChooseSizeTshirtInstructions,
  },
  model: {
    male: {
      imageUrl: ex2MImg.src,
      modelSize: defineMessage({
        defaultMessage:
          'Model is wearing size Medium. He usually wears a size Medium.',
      }),
      modelMeasurements: [
        defineMessage({
          defaultMessage: 'Height: 183 cm / 6’',
        }),
        defineMessage({
          defaultMessage: 'Chest: 48 cm / 19”',
        }),
      ],
    },
  },
};
